module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (16).4c0bf8da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (16).jpg
// module id = 338
// module chunks = 0